export const DEFAULT_PAGE_NUMBER = 0;
export const DEFAULT_PAGE_SIZE = 50;
export const PAGE_SIZE_OPTIONS = [
	{ value: 50, label: '50' },
	{ value: 100, label: '100' },
	{ value: 250, label: '250' },
];
export const DAY_CREW_TIMELINE_FORMAT = 'dddd';

export const normalizePageSize = (pageSize) => {
	const numericPageSize = Number(pageSize);
	const isSupportedPageSize = PAGE_SIZE_OPTIONS.some(({ value }) => value === numericPageSize);

	return isSupportedPageSize ? numericPageSize : DEFAULT_PAGE_SIZE;
};
